import { ReactElement, useEffect } from 'react';
import { UIModal, UIModalContent, UIModalFooter, UIModalHeader } from '@/ui';
import { useUnassignedAlerts } from '../providers';
import { MiniTaskItem } from './mini-task-item';
import { useNavigate } from 'react-router';
import { useTasksTranslation } from '../hooks';

type UnassignedAlertsModalProps = {
    isOpen: boolean;
    onClose: () => void;
};
export function UnassignedAlertsModal(
    props: UnassignedAlertsModalProps
): ReactElement {
    const { isOpen, onClose } = props;

    return (
        <UIModal isOpen={isOpen} onClose={onClose}>
            {isOpen ? <Content {...props} /> : null}
        </UIModal>
    );
}

function Content(props: UnassignedAlertsModalProps): ReactElement {
    const { onClose } = props;

    const { t } = useTasksTranslation();
    const navigate = useNavigate();

    const { tasks } = useUnassignedAlerts();

    useEffect(() => {
        if (tasks.length === 0) {
            onClose();
        }
    }, [tasks.length, onClose]);

    return (
        <>
            <UIModalHeader
                title={t('components.unassigned_alerts_modal.title')}
            />
            <UIModalContent>
                {tasks.length > 0 && (
                    <div
                        style={{
                            display: 'flex',
                            maxHeight: 400,
                            flexDirection: 'column',
                            overflowY: 'auto'
                        }}
                    >
                        {tasks.map((task) => (
                            <MiniTaskItem
                                key={task.id}
                                task={task}
                                onClick={() => {
                                    onClose();
                                    void navigate(
                                        `/company/${task.companyId}/tasks/${task.id}`
                                    );
                                }}
                            />
                        ))}
                    </div>
                )}
            </UIModalContent>
            <UIModalFooter
                actions={[
                    {
                        text: t('shared.labels.close'),
                        onClick: onClose
                    }
                ]}
            />
        </>
    );
}
